import styled from "styled-components";

export const Buttons = styled.div`
  margin-top: 5%;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
